import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Table, TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TagModule } from 'primeng/tag';

import { SchedaIntervento } from '@/core/models/models/pages/scheda-intervento';
import { SchedaInterventoService } from '@/core/service/scheda-intervento.service';

@Component({
    selector: 'app-scheda-interventi',
    standalone: true,
    templateUrl: './scheda-interventi.component.html',
    styleUrls: ['./scheda-interventi.component.scss'],
    providers: [ConfirmationService, MessageService],
    imports: [CommonModule, TableModule, ToolbarModule, ButtonModule, InputTextModule, RippleModule, ConfirmDialogModule, ToastModule, TagModule]
})
export class SchedeInterventiComponent implements OnInit {
    @ViewChild('dt') dt!: Table;

    loading = false;
    records: SchedaIntervento[] = [];

    constructor(
        private service: SchedaInterventoService,
        private confirmation: ConfirmationService,
        private message: MessageService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.loading = true;
        this.service.list().subscribe({
            next: (res) => (this.records = res ?? []),
            error: () => (this.records = []),
            complete: () => (this.loading = false)
        });
    }

    onExportCSV() {
        this.dt.exportCSV();
    }

    onNuovo() {
        this.router.navigate(['/scheda-interventi/nuovo']);
    }

    onVisualizza(row: SchedaIntervento) {
        this.router.navigate(['/scheda-interventi', row.id], { queryParams: { mode: 'view' } });
    }

    onModifica(row: SchedaIntervento) {
        this.router.navigate(['/scheda-interventi', row.id]);
    }

    onElimina(row: SchedaIntervento) {
        const id = row?.id;
        if (id == null) {
            this.message.add({ severity: 'warn', summary: 'ID mancante', detail: 'Impossibile eliminare: ID non presente' });
            return;
        }
        const payload = {
            deviatoioId: row.deviatoiRiepilogoGenerale?.id ?? null,
            interventoId: row.id
        };
        this.confirmation.confirm({
            message: `Confermi l'eliminazione della scheda #${id}?`,
            header: 'Conferma eliminazione',
            icon: 'pi pi-exclamation-triangle',
            acceptButtonStyleClass: 'p-button-danger',
            acceptIcon: 'pi pi-trash',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => {
                this.service.delete(payload).subscribe({
                    next: () => {
                        this.message.add({ severity: 'success', summary: 'Eliminato', detail: 'Scheda eliminata correttamente' });
                        this.load();
                    },
                    error: (err) => {
                        console.error('Errore eliminazione scheda', err);
                        this.message.add({ severity: 'error', summary: 'Errore', detail: 'Eliminazione non riuscita' });
                    }
                });
            }
        });
    }

    // ===== helpers tabella =====
    formatDate(d?: string | null): string {
        if (!d) return '-';
        try {
            return new Date(d).toLocaleString();
        } catch {
            return d;
        }
    }

    boolSeverity(v: boolean | null | undefined): 'success' | 'danger' | 'warning' {
        if (v === true) return 'success';
        if (v === false) return 'danger';
        return 'warning';
    }

    boolLabel(v: boolean | null | undefined): string {
        if (v === true) return 'Sì';
        if (v === false) return 'No';
        return '-';
    }
}
